<template>
  <div>
    <a-card class="step-card">
      <div class="step-card-content">
        <a-steps :class="[4, 13, 18].includes(templateId) ? 'step-card-steps-with-nodes' : 'step-card-steps'" size="small" :current="pCurrent" :style="{ width: `${stepsI.length * 202}px` }">
          <a-step v-for="(step, idx) in stepsI" :key="step.id" :title="step.name">
            <a-steps slot="description" direction="vertical" :current="childCurrent(step.id)">
              <a-step v-for="(node, index) in childStepMap[step.id]" :key="index" :title="node.name">
                <div slot="icon" class="child-step-icon">
                  <div v-if="childCurrent(step.id) <= index">
                    {{ `${idx + 1}.${index + 1}` }}
                  </div>
                  <a-icon v-else type="check" />
                </div>
              </a-step>
            </a-steps>
          </a-step>
        </a-steps>
      </div>
    </a-card>
  </div>
</template>
<script>
import { brStatusMapingList } from '@/pages/business/requirement/util';
export default {
  components: {},
  props: {
    current: {
      type: Number,
      default: 0
    },
    currentStepId: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => {
        return [];
      }
    },
    abstract: {
      type: Array,
      default: () => {
        return [];
      }
    },
    templateId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      brStatusMapingList,
      abstractDict: {},
      stepsI: [],
      childStepMap: {}
    };
  },
  computed: {
    childCurrent() {
      return pStepId => {
        // 找到原step的节点
        const stp = this.steps[this.current];
        const childSteps = this.childStepMap[pStepId];
        if (childSteps && childSteps.length > 0) {
          return childSteps.findIndex(item => item.id === stp.id);
        }
        return -1;
      };
    },
    pCurrent() {
      // 主状态节点
      const c = 0;
      if (this.steps.length > 0) {
        // 找到原step的节点
        const stp = this.steps[this.current];
        // 找到聚合后的step节点
        const nStep = this.stepsI.find(i => i.id === stp.id);
        if (nStep) {
          // 如果当前节点在聚合后仍存在则直接获取index即可
          return this.stepsI.findIndex(item => item.id === nStep.id);
        } else {
          // 如果不存在，需要获取父节点的聚合id
          const groupNode = brStatusMapingList.find(item => item.child.includes(stp.id));
          return this.stepsI.findIndex(item => item.id === groupNode.value);
        }
      }
      return c;
    },
    planLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:project:testplan:detail',
          query: { planId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    steps: {
      immediate: true,
      handler(val) {
        const __steps = [...this.steps];
        if (this.brStatusMapingList && this.brStatusMapingList.length > 0) {
          for (let index = 0; index < this.brStatusMapingList.length; index++) {
            const element = this.brStatusMapingList[index];
            const c = element.child;
            const idxs = __steps.filter(item => c.includes(item.id)).map(it => __steps.findIndex(i => i.id === it.id));
            if (idxs.length > 0) {
              const childStep = [];
              idxs.forEach(i => {
                childStep.push(__steps[i]);
              });
              this.childStepMap[element.value] = childStep;
              const minNumber = Math.min(...idxs);
              __steps.splice(minNumber, idxs.length, { id: element.value, name: element.label });
            }
          }
        }
        this.stepsI = __steps;
      }
    },
    abstract: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          val.forEach(item => {
            this.$set(this.abstractDict, item.step_id, item);
          });
        }
      }
    }
  },
  methods: {}
};
</script>
<style lang="less">
.step-card {
  .ant-card-body {
    padding: 18px 20px 0px 20px;
  }
}

.sub-node {
  margin-top: 5px;
  margin-left: -20px;

  .ant-list-item-no-flex {
    padding-top: 2px;
    padding-bottom: 2px;
  }
}

.bgcolor .ant-tooltip-inner {
  color: #333 !important;
  background-color: #fff !important;
  width: 550px;
}
</style>
<style lang="less" scoped>
.step-card {
  .step-card-content {
    overflow: auto;
    padding: 10px 0;

    .step-card-steps {
      margin-bottom: 12px;
    }

    .step-card-steps-with-nodes {
      /deep/ .ant-steps-item-description {
        margin-left: -32px;
        max-width: 188px !important;
        margin-top: 8px;

        .child-step-icon {
          font-size: 10px;
          font-weight: 400;
          background: #85b5fa;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          color: #fff;
        }

        .ant-steps-item-active {
          .child-step-icon {
            background: #448ef7;
          }
        }

        .ant-steps-item-finish {
          .child-step-icon {
            background: #fff;
            border: 1px solid #448ef7;
            color: #448ef7;
          }
        }

        .ant-steps-item-icon {
          margin-right: 8px;
        }

        .ant-steps-item-container {
          margin-bottom: 8px;
        }

        .ant-steps-item-content {
          min-height: 0;
          .ant-steps-item-title {
            font-size: 13px;
            line-height: 24px;
          }
        }
      }

      /deep/ .ant-timeline-item-head-custom .ant-tag {
        width: 65px;
      }

      /deep/ .ant-timeline-item-tail {
        left: 0;
      }
    }
  }
}
</style>
